import { render, staticRenderFns } from "./UserBehaviorModal.vue?vue&type=template&id=97c8526e&scoped=true"
import script from "./UserBehaviorModal.vue?vue&type=script&lang=js"
export * from "./UserBehaviorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c8526e",
  null
  
)

export default component.exports